<template>
  <v-card>
    <v-card-title>
      <div class="headline">Domestic Worker Details</div>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.tranNo}}</v-subheader>
          <div class="title">{{maid.fwTransNo}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.workPermitType}}</v-subheader>
          <div class="title">{{formatWorkPermitType(maid.fwWPType)}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.workPermit}}</v-subheader>
          <div class="title">{{maid.fwWPNo}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.name}}</v-subheader>
          <div class="title">{{maid.fwName}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.nationality}}</v-subheader>
          <div class="title">{{formatMaidNationality(maid.fwNationality)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.passport}}</v-subheader>
          <div class="title">{{maid.fwPassport}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.dob}}</v-subheader>
          <div class="title">{{maid.fwDob}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.gender}}</v-subheader>
          <div class="title">{{formatGender(maid.fwGender)}}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { maidNationality, workPermitType } from '@/const/underwriting/maid'
import { globalMixin } from './globalMixin'

export default {
  data() {
    return {
      labels: {
        name: 'Name as in Passport',
        passport: 'Passport No.',
        tranNo: 'SB Transmission No.',
        workPermit: 'Work Permit No.',
        workPermitType: 'Work Permit Type',
        nationality: 'Nationality',
        dob: 'Date of Birth',
        gender: 'Gender'
      }
    }
  },
  methods: {
    formatWorkPermitType(wp) {
      return workPermitType[wp]
    },
    formatMaidNationality(nationality) {
      return maidNationality[nationality]
    }
  },
  computed: {
    maid() {
      return this.$store.state.adminMember.member.trans.insuredInfo
    }
  },
  mixins: [globalMixin]
}
</script>

<style>
</style>
